import React from 'react'
import {useNavigate} from 'react-router-dom'

import {getLocalStorageValue} from 'config/helper'

import {WaltsFood} from './WaltsFood'
import {Redners} from './Redners'

const Config = {
  323: Redners,
  13: WaltsFood,
}

function WeeklyAdsDigitalPage() {
  const onWeeklyAdsPage = window.location.pathname === '/weekly-ads-digital'
  const navigate = useNavigate()

  if (!onWeeklyAdsPage) {
    navigate('/home')
    return null
  }

  const clientId = getLocalStorageValue('RSAclient-id')

  const Component = Config[clientId]
  if (Component) {
    return <Component />
  }

  return <h1>Invalid Client ID</h1>
}

export default WeeklyAdsDigitalPage
